import Image from 'next/legacy/image';
import React from 'react';
// import { StarIcon } from '@heroicons/react/solid';
import { useDrawer } from '../Drawer';
import { StaticImageData } from 'next/image';

interface TopCarPaneldProps {
  company: string;
  type: string;
  rating: string;
  image: StaticImageData;
  wattage: string;
  warranty: string;
  bestSeller: boolean;
  brandName?: string;
}

export const TopCardPanel: React.FC<TopCarPaneldProps> = (props) => {
  const { toggle } = useDrawer();
  return (
    <div className="bg-white border-2 border-primary rounded-md w-44">
      {props.bestSeller ? (
        <div className="mx-auto w-2/3 rounded-b-md bg-primary pb-1 m-0">
          <p className="text-center text-white m-0">Best Seller</p>
        </div>
      ) : (
        <div className="mt-3"></div>
      )}

      <div className="flex flex-row justify-between px-4 ">
        <div className="flex flex-col text-left">
          <p className="text-gray-700 m-0 text-xs">{props.type}</p>
          <p className="text-base m-0 font-semibold text-black">
            {props.brandName}
          </p>

          <p className="font-medium text-black m-0 h-11 text-sm">
            {props.company}
          </p>

          {/* <div className="flex items-center">
            {[0, 1, 2, 3, 4].map((count) => (
              <StarIcon
                key={count}
                className="text-yellow-400"
                aria-hidden="true"
              />
            ))}
          </div> */}
        </div>
      </div>
      <div className="w-40 h-40 relative">
        <Image
          src={props.image}
          alt={`${props.company} + Panel`}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div className="flex flex-col px-4 py-2">
        <div className="flex flex-row justify-between ">
          <p className="text-black  m-0 text-sm">Efficiency</p>
          <p className="text-black font-medium m-0 text-sm">{props.rating}</p>
        </div>
        <div className="flex flex-row justify-between ">
          <p className="text-black  m-0 text-sm">Wattage</p>
          <p className="text-black font-medium m-0 text-sm">{props.wattage}</p>
        </div>
        <div className="flex flex-row justify-between">
          <p className="text-black  m-0 text-sm">Warranty</p>
          <p className="text-black font-medium m-0 text-sm">{props.warranty}</p>
        </div>
      </div>
      <button
        className="bg-primary-500 text-white font-medium w-full p-1"
        onClick={toggle}
      >
        Get Quote
      </button>
    </div>
  );
};
